import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

/**
 * Loads every FSA plan config once and exposes a planId → config map.
 * Shared by surfaces that flag FSA readiness / show election limits
 * (broker Available Plans, employee enrollment) so the fetch isn't duplicated.
 */
export function useFsaConfigs() {
  const { data = [], isFetched } = useQuery<any[]>({
    queryKey: ["/api/fsa-configs"],
    queryFn: async () => {
      const res = await fetch("/api/fsa-configs");
      if (!res.ok) return [];
      return res.json();
    },
  });

  const fsaConfigByPlanId = useMemo(() => {
    const map = new Map<number, any>();
    (data as any[]).forEach((c) => map.set(c.planId, c));
    return map;
  }, [data]);

  return { fsaConfigs: data as any[], fsaConfigByPlanId, isFetched };
}
